"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(string) {
  return string.replace(/-./g, function (x) {
    return x.toUpperCase()[1];
  });
};

exports["default"] = _default;